export default {
    createDefaultReplyInfo() {
        return {
            // 기본 데이터
            hasReply: true,
            hasActionOk: true,
            hasCveIdAgree: null,
            hasOpenSrc: false,
            hasHomePage: false,
            replyCn: "",
            replyCnHtml: null,
            homePageUrl: null,
            actionGuide: "",
            actionGuideHtml: null,
            noVulnVerReason: null,
            submitType: "P",
            hasNoVulnVer: false,
            replyDate: null,
            deployDate: null,
            swNm: null,
            platform: null,
            openSrcNm: null,
            openSrcStore: null,
            openSrcFile: null,
            marketShare: 0.0,
            marketRanking: 0,
            regDate: null,
            bigo: null,
            repTextData: null,
            vulnVersionRange: [this.createDefaultVulnVersionRange()],
            patchVersionMap: [this.createDefaultPatchVersionMap()],
            deliveryStatus: [],
            patchGuides: [],
        };
    },
    createDefaultSubmitInfo() {
        return {
            submitRequestInfos: [],
            hasPatchUpdatable: true,
        };
    },
    createDefaultEvalInfo() {
        return {
            cvss: null,
            severity: null,
            evlItem: {},
        };
    },
    getTotalInfo() {
        return {
            submitInfo: this.createDefaultSubmitInfo(),
            replyInfo: this.createDefaultReplyInfo(),
            cvssEval: this.createDefaultEvalInfo(),
            uploadFile: null,
            actionGuideFiles: null,
        };
    },
    createDefaultVulnVersionRange() {
        return {
            minVersion: "",
            minVersionRange: "INCLD",
            maxVersion: "",
            maxVersionRange: "INCLD",
        };
    },
    createDefaultPatchVersionMap() {
        return {
            vulnVersion: "",
            patchedVersion: "",
            fileHash: "",
        };
    },
};
